/**
 * @generated SignedSource<<be0095300e10daa6bbeddd382aaa7d96>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppUserDestinationInputTransferMutation$variables = {
  appId: string;
  toEmail: string;
};
export type AppUserDestinationInputTransferMutation$data = {
  readonly requestAppTransferToUser: {
    readonly transferRequestDestination: {
      readonly email?: string;
    } | null;
  };
};
export type AppUserDestinationInputTransferMutation = {
  response: AppUserDestinationInputTransferMutation$data;
  variables: AppUserDestinationInputTransferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toEmail"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appId",
    "variableName": "appId"
  },
  {
    "kind": "Variable",
    "name": "toEmail",
    "variableName": "toEmail"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    }
  ],
  "type": "UserDestination",
  "abstractKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppUserDestinationInputTransferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "requestAppTransferToUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppUserDestinationInputTransferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "App",
        "kind": "LinkedField",
        "name": "requestAppTransferToUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "transferRequestDestination",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/)
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "949259570c4a835a4a759dd31ad5fb97",
    "id": null,
    "metadata": {},
    "name": "AppUserDestinationInputTransferMutation",
    "operationKind": "mutation",
    "text": "mutation AppUserDestinationInputTransferMutation(\n  $appId: ID!\n  $toEmail: String!\n) {\n  requestAppTransferToUser(appId: $appId, toEmail: $toEmail) {\n    transferRequestDestination {\n      __typename\n      ... on UserDestination {\n        email\n      }\n      ... on Organization {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "94c88cc35eeefb792dc23805e6c19c32";

export default node;
